// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class DeliverableVM  {
    _originalTypeClassName = "Loom.BO.DeliverableVM";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
DeliverableVM.translate = translateService;
}
this.project_acronym = null;
this.wp_number = null;
this.leader_shortname = null;
this.num = null;
this.title = null;
this.description = null;
this.type = null;
this.dissemination_level = null;
this.month_due = null;
this.DeliverableVMKey = null;
this._key = this.DeliverableVMKey = 0; 
}

static translate: TranslateService;
_key: any;
project_acronym:any;
wp_number:any;
leader_shortname:any;
num:any;
title:any;
description:any;
type:any;
dissemination_level:any;
month_due:any;
private _DeliverableVMKey:any;
get DeliverableVMKey(): any {
    return this._DeliverableVMKey;
  }
set DeliverableVMKey(value: any) {
    this._DeliverableVMKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.DeliverableVMKey == null || $this.DeliverableVMKey == 0;
            }


}